module.exports = __webpack_public_path__ + "img/mummy.43b9ea9b.jpg";